import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { isFirebaseConfigured } from '@/lib/firebase'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, initialized, isAdmin } = useAuthStore()
  const location = useLocation()

  if (!initialized) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-luxury-950">
        <div className="flex flex-col items-center gap-4">
          <div className="h-12 w-12 animate-spin rounded-full border-2 border-gold-500 border-t-transparent" />
          <p className="text-sm text-zinc-500">Loading Ooudh Kraft...</p>
        </div>
      </div>
    )
  }

  if (!isFirebaseConfigured()) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-luxury-950 p-6">
        <div className="glass-card gold-border-glow max-w-md p-8 text-center">
          <h1 className="font-display text-xl font-bold gold-gradient-text mb-2">
            Firebase Not Configured
          </h1>
          <p className="text-sm text-zinc-500">
            Add your Firebase credentials to <code className="text-gold-700">.env</code>{' '}
            to connect to Firestore. All data is loaded from Firebase only.
          </p>
        </div>
      </div>
    )
  }

  if (!user || !isAdmin) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}
